<template>
	<v-app id="change-password">
		<v-container fluid fill-height>
			<v-layout align-center justify-center>
				<div class="text-xs-center" style="width: 380px;">
					<h1>Ustaw hasło</h1>
					<v-flex class="my-3">
						Hasło powinno zawierać co najmniej:
						10 znaków,
						jedną dużą literę,
						jedną małą literę,
						jedną cyfrę,
						jeden znak specjalny.
					</v-flex>
					<v-flex xs12>
						<v-text-field
							browser-autocomplete="off"
							name="Hasło"
							label="Hasło"
							aria-label="password"
							for="setup-password-view-password"
							id="setup-password-view-password"
							v-model="formData.password"
							data-vv-name="password"
							data-vv-as="Hasło"
							:type="showPassword? 'text' : 'password'"
							:append-icon="showPassword? 'visibility' : 'visibility_off'"
							@click:append="showPassword = !showPassword"
							:error-messages="vErrors.collect('password')"
							@click="disableErrorMessage"
							v-validate="'required'"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							browser-autocomplete="off"
							name="Potwierdź"
							label="Potwierdź hasło"
							aria-label="password confirmation"
							for="setup-password-view-password-confirmation"
							id="setup-password-view-password-confirmation"
							v-model="formData.passwordConfirmation"
							data-vv-name="passwordConfirmation"
							data-vv-as="Potwierdź"
							:type="showConfirm? 'text' : 'password'"
							:append-icon="showConfirm? 'visibility' : 'visibility_off'"
							@click:append="showConfirm = !showConfirm"
							:error-messages="vErrors.collect('passwordConfirmation')"
							@click="disableErrorMessage"
							v-validate="'required'"
						></v-text-field>
					</v-flex>
					<v-expand-transition>
						<div v-show="showErrorMessage" style="color: red">
							{{errorMessage}}
						</div>
					</v-expand-transition>
					<div>
						<v-btn color="primary" @click="setUpPassword">Ustaw</v-btn>
					</div>
				</div>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	import {Api} from "@/api";
	import {Credentials} from "@/api/generated/Credentials";
	import dataValidation from "../utils/dataValidation";

	export default {
		name: "ResetPasswordView",

		data() {
			return {
				publicPath: process.env.BASE_URL,
				formData: {
					password: "",
					token: "",
					passwordConfirmation: "",
				},
				errorMessage: '',
				showErrorMessage: false,

				showPassword: false,
				showConfirm: false,
			};
		},

		methods: {
			disableErrorMessage() {
				this.showErrorMessage = false;
			},

			setUpPassword() {
				this.$validator.validateAll().then((result) => {
					if (!result) return;
					let validationResult = dataValidation.validPassword(this.formData.password, this.formData.passwordConfirmation);
					if (validationResult === "OK") {
            Credentials.postSetupPassword(this, this.formData, () => {
                  this.$router.push("/setup-password-confirmed");
                },
                errorResponse => {
                  this.errorMessage = errorResponse.errors[0];
                  this.showErrorMessage = true;
                });
					} else {
						this.errorMessage = validationResult;
						this.showErrorMessage = true;
					}
				});
			}
		},

		beforeMount() {
			if (!this.$route.query.token) {
        this.$router.push("/not-found");
      }

      this.formData.token = this.$route.query.token;
      Api.getWithParam(this, "/credentials/user-exist", {token: this.formData.token}, response => {
        if (response.status !== "OK") {
          this.$router.push("/not-found");
        }
      }, () => {
        this.$router.push("/not-found");
      });
		}
	};
</script>

<style scoped>
	label span,
	label span a {
		font-size: 16px;
	}
</style>
